const Step = require("app/components/checkout/Step");
const Form = require("app/components/forms/DynamicForm");
const env = require("app/services/env");
const ZipField = require("app/components/fields/ZipCity");
const PhoneField = require("app/components/fields/Phone");
const queryObject = require("app/util/queryObject");
const assign = require("object-assign");
const PropTypes = require("prop-types");
const NumericField = require("app/components/fields/Numeric");
const Tooltip = require("app/components/mixins/Tooltip");
const RestrictedInput = require("app/components/fields/RestrictedInput");
const CvrField = require("app/components/fields/CVR");
const Textarea = require("app/components/fields/Textarea");
const Trans = require('app/components/trans/Trans')

class ClientForm extends Form {

	static get propTypes() {
		return assign({}, super.propTypes, {
			cart: PropTypes.object.isRequired,
			pipelines: PropTypes.object.isRequired
		});
	}

	static get defaultProps() {
		return {
			performValidationOnLoad: true
		};
	}

	constructor(props) {
		super(props);
		this.state = assign({}, this.state, {
			cart: props.cart,
			origin: props.cart.client.origin || "domestic"
		});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.cart !== this.cart) {
			this.setState({cart: nextProps.cart, origin: nextProps.cart.client.origin});
		}
	}

	get cart() {
		return this.state.cart;
	}

	get pipelines() {
		return this.props.pipelines;
	}

	isFuneral() {
		return this.cart.productType === "funeral";
	}

	performSubmit(form) {
		// Set as loading
		this.setState({loading: true});

		return this.pipelines.client.update.dispatch(this.buildPayload(form))
			.then(cart => {
				this.onComplete(cart);
				return cart;
			})
			.catch(error => {
				this.onError(error.response.data);
				throw error;
			});
	}

	performValidation() {
		const form = this.bodyElement.querySelector("form");

		if (form == undefined) {
			return;
		}

		return this.pipelines.client.validate.dispatch(this.buildPayload(form))
			.then(() => {
				this.onValidationSuccess();
			})
			.catch(error => {
				this.onValidationError(error.response.data);
				//throw error;
			});
	}

	submit() {
		return this.performSubmit(this.formElement);
	}

	value(query, defaultValue = null) {
		return queryObject(this.cart, query, defaultValue);
	}

	_onOriginChange = (e) => {
		this.setState({
			origin: e.target.checked ? "abroad" : "domestic"
		});
	};

	renderZipCode() {
		if (this.state.origin !== "domestic") {
			return;
		}

		return (
			<div className="field required">
				<label htmlFor="clientZipCodeInput"><Trans>Postnr.</Trans></label>
				{this.renderValidity("czipCode")}
				<ZipField id="clientZipCodeInput" name="czipCode" zip={this.value("client.zipcode", "")}
                          city={this.value("client.city", "")}
                          regionPlaceholder={translate('Delstat')}
                          region={this.value("client.region", "")}
                          zipPlaceholder={translate("Fx. 5000")}
                          cityPlaceholer=""
                          required={true}
                          onChange={this.onChange("czipCode")}/>
				{this.renderError("czipCode")}
			</div>
		);
	}

	renderForm() {
		return (
			<form ref={el => this.formElement = el} onSubmit={this.onSubmit}>
				{this.renderError("status", "status-error")}

				<div className="inputs">

					<div className="field checkbox-field">
						<label className="hide-desktop"><Trans>Jeg bestiller fra udlandet</Trans></label>
						<input id="originCheckbox" type="checkbox"
									 name="corigin" value="abroad"
									 checked={this.state.origin === "abroad"}
									 onChange={this._onOriginChange}
						/>
						<label htmlFor="originCheckbox"><Trans>Jeg bestiller fra udlandet</Trans></label>
					</div>

					<div className="field required">
						<label htmlFor="clientNameInput"><Trans>Dit navn</Trans></label>
						{this.renderValidity("cname")}
						<input defaultValue={this.value("client.name", "")} type="text"
									 id="clientNameInput" autoComplete="name" name="cname"
									 required={true}
									 onInput={this.onChange("cname")}
									 placeholder={translate("Fx. Elisabeth Hansen")} />
						{this.renderError("cname")}
					</div>

					<div className="field required">
						<label htmlFor="clientPhoneInput"><Trans>Telefon nr</Trans></label>
						{this.renderValidity("cphone")}
						<PhoneField defaultValue={this.value("client.phone", "")} id="clientPhoneInput"
												name="cphone" autoComplete="phone" required={true}
												onInput={this.onChange("cphone")}
												placeholder={translate("Fx. 35858012")} />
						{this.renderError("cphone")}
					</div>

					<div className="field required">
						<label htmlFor="clientEmailInput"><Trans>Email</Trans></label>
						{this.renderValidity("cemail")}
						<input defaultValue={this.value("client.email")} autoComplete="email" type="email"
									id="clientEmailInput" name="cemail" required={true}
									onInput={this.onChange("cemail")}
									placeholder={translate("Fx. navn@bloomit.dk")} />
						{this.renderError("cemail")}
					</div>

					<div className="field">
						<label htmlFor="clientCompanyInput"><Trans>Firma</Trans></label>

						{this.renderValidity("ccompany")}
						<input defaultValue={this.value("client.company", "")} type="text"
									id="clientCompanyInput" autoComplete="company" name="ccompany"
									onInput={this.onChange("ccompany")}
									placeholder={translate("Fx. Bloomit Danmark ApS")} />
						{this.renderError("ccompany")}
					</div>

					<div className="field required">
						<label htmlFor="clientAddressInput"><Trans>Adresse</Trans></label>
						{this.renderValidity("caddress")}
						<input defaultValue={this.value("client.address", "")} type="text"
									 id="clientAddressInput" autoComplete="address" name="caddress"
									 required={true}
									 onInput={this.onChange("caddress")}
									 placeholder={translate("Fx. H. C. Andersensvej 1")} />
						{this.renderError("caddress")}
					</div>

					{this.renderZipCode()}

					<div className="field">
						<label htmlFor="clientCvrInput"><Trans>CVR nr</Trans></label>

						{this.renderValidity("ccvr")}
						<CvrField defaultValue={this.value("client.cvr", "")} type="text"
											id="clientCvrInput" autoComplete="cvr" name="ccvr"
											onInput={this.onChange("ccvr")}/>
						{this.renderError("ccvr")}
					</div>

					{/*
					  <div className="field">
					  	<label htmlFor="eanInput">EAN Nr</label>

					  	{this.renderValidity("ean")}
					  	<NumericField defaultValue={this.value("client.ean", "")} type="text"
					  								id="eanInput" name="cean"
					  								onInput={this.onChange("ean")}/>
					  	{this.renderError("ean")}
					  </div>

					  <div className="field">
					  	<label htmlFor="requisitionInput">Mærke til fakturaen</label>

					  	{this.renderValidity("requisition")}
					  	<input defaultValue={this.value("client.requisition", "")} type="text"
					  				 id="requisitionInput" name="crequisition"
					  				 onInput={this.onChange("requisition")}/>
					  	{this.renderError("requisition")}
					  </div>
					*/}

				</div>

				<div className="anonymity-section">
					<div className="inputs">
						<div className="section-title">
                          <Trans> Jeg ønsker at være anonym </Trans>
							<Tooltip content={translate("Marker dette felt hvis du ønsker at være anonym i forhold til modtageren. Navn gives aldrig med, med mindre det står i korttekst.")} positionMobile="sw" />
						</div>
						<p> <Trans> Jeg ønsker at være anonym i forhold til modtageren. </Trans> </p>
						<div className="field checkbox-field">
							<input id="anonymousCheckbox" type="checkbox"
										name="anonymous" value="1"
										defaultChecked={this.value("options.anonymous", false) === true}
										onChange={this.onChange("anonymous")}
							/>
							<label htmlFor="anonymousCheckbox"><Trans> Jeg ønsker at være anonym </Trans></label>
						</div>
					</div>
				</div>

				<div className="remark">
					<div className="section-title">
						<Trans>En sidste bemærkning?</Trans>
						<Tooltip
							content={translate("Feltet er til ekstra leveringsdetaljer. Fx hvis modtager er hørehæmmet og vi får denne information, så tager vores chauffør sig ekstra tid ved leveringen. Her kan gøres bemærkninger i forhold til tidspunkter for receptioner mv., eller hvis modtagers navn ikke står på postkassen, så vi ved at vi leverer på den rigtige adresse alligevel.")} />
					</div>
					<p> <Trans> Læg en kort bemærkning til din bestilling </Trans> </p>
					<Textarea name="notes"
							  maxLength={170} limitLines={2}
							  defaultValue={this.value("notes", "")}
							  placeholder={translate('Bemærkninger kan eksempelvis være allergier, dårlig hørelse osv.')} />
				</div>
			</form>
		);
	}

}

class Client extends Step {

	get baseClassName() {
		return super.baseClassName + " step-client";
	}

	get gaInfo(){
		return {
			'page_title' : translate('Ser kurven') ,
			'page_path': translate('/ser-oplysninger/')
		};
	}

	get title() {
		return translate('Dine oplysninger');
	}

	get description() {
		return (
			<span> <Trans> Udfyld og bekræft at dine oplysninger er korrekte </Trans> </span>
		);
	}

	submit() {
		return this.formElement.submit();
	}

	renderStep() {
		return (
			<ClientForm ref={el => this.formElement = el} cart={this.cart} pipelines={this.pipelines}/>
		);
	}

}

module.exports = Client;
